module.exports = __webpack_public_path__ + "static/img/goals_poisson_mb.b616b7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/goals_poisson_mb.png
// module id = hZmp
// module chunks = 1